import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 60 * 1000, // 1 minute
    },
    mutations: {
      // Prevent mutations from throwing unhandled errors
      // Errors should be handled in the onError callback of individual mutations
      throwOnError: false,
    },
  },
});

export { queryClient };
